export default __webpack_public_path__ + "static/hp-brand-deck-23-8857cce1dced6e05992955bdc0a93a18.png";